import {
  PersonalizeExperiences,
  SimplifiedPersonalizeContent
} from 'types/api/personalize'

// aux function to convert the response to a usable format for promotions component
export function simplifyPromotions(
  content: PersonalizeExperiences,
  { id }: { id: string }
): SimplifiedPersonalizeContent[] {
  if (!content || !content.experiences) {
    return []
  }

  return Object.keys(content.experiences)
    .filter((key) => key.startsWith(id))
    .map((key) => {
      const { payload } = content.experiences[key]

      // Simplify the properties of the payload
      const simplifiedPayload = Object.fromEntries(
        Object.entries(payload).map(([propKey, propValue]) => {
          if (
            propValue &&
            typeof propValue === 'object' &&
            'value' in propValue
          ) {
            return [propKey, propValue.value] // Replace with the value property
          }
          return [propKey, propValue] // Keep the original value if not applicable
        })
      )

      return {
        id: key,
        ...simplifiedPayload
      }
    })
}
